import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '11px 12px',
    borderRadius: 12,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background-color 120ms',
    '&:hover': {
      backgroundColor: theme.palette.labraChat.hoverBg,
    },
    '&:disabled': {
      cursor: 'default',
    },
  },
  iconTile: {
    width: 34,
    height: 34,
    flex: 'none',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.labraChat.hoverBgAlt,
    color: theme.palette.labraText.secondaryDescription,
    '& svg': {
      fontSize: 15,
    },
  },
  title: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.labraText.darkTertiary,
  },
  time: {
    flex: 'none',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '18px',
    color: theme.palette.labraText.secondaryDescription,
  },
}))
